
import { logout } from "features/auth/store/slice";
import { takeEvery } from "redux-saga/effects";

function* handleLogout(){
  try{
    // yield call(removeStorage, APP_TOKEN_NAME);
    // yield call(history.push, PAGE_URL.Login);
  }
  catch(e){}
}

export default function* appSaga(){
  yield takeEvery(logout.type, handleLogout);
}
